// extracted by mini-css-extract-plugin
export default {"detailsViewer":"KGKh_QOab5ltpxKJIhVz","detailsViewerMainView":"JqOMvXjejBJUeRL4jK9z"};